/**
 * ENG-5739 — one name for the hire action, defined once.
 *
 * Four surfaces named the same action four ways: the drawer header said
 * `Hire this expert`, the profile sidebar `Hire for ongoing work`, the
 * consultation page `Hire Expert for Ongoing Engagement`. A customer clicked
 * one string and landed on a drawer titled another.
 *
 * "Ongoing" is legacy framing from the Typeform-era program these entry points
 * used to open (the `HireExpert.tsx` dialog, deleted in ENG-6301). An
 * engagement is scoped work under a not-to-exceed ceiling and can be short, so
 * nothing about it is necessarily ongoing.
 *
 * **Known deviation from the prototype, and it is deliberate.** Brian's
 * Storybook (`components/HireExpertDrawer/form.ts#drawerTitle`, and the Path B
 * and Path D story docs) writes both strings without the article: `Hire Expert
 * for Engagement` and `Hire for Engagement`. He then asked for the article on
 * 2026-09-04 (Notion FB-182, verbatim: "top of the hire expert drawer should
 * say 'Hire Expert for an Engagement'"). He authored both, so the later ask
 * wins. Recorded here so the prototype diff does not read as a fresh defect.
 *
 * The prototype's `drawerTitle` is keyed on creation path, which this file is
 * not, because the two paths that differ are not live: `from_candidate_card`
 * has no entry point and `customer_introduced` is ENG-5699. The two live paths,
 * `post_consultation` and `from_profile`, share one title.
 */

/**
 * The two strings below are deliberately NOT the same string, and reconciling
 * them is a regression, not a fix: the CTA sits next to the expert it acts on
 * and does not need to name them, while the drawer header stands alone and
 * does. Brian authored both (FB-182). QA has already reported the difference
 * once as a missed rename.
 */

/** Entry-point CTAs that open the hire drawer. */
export const HIRE_ACTION_LABEL = 'Hire for an Engagement';

/** The drawer's own header, and any dialog that stands in for it. */
export const HIRE_DRAWER_TITLE = 'Hire Expert for an Engagement';
